export function getWhatsappUrl(phoneNumber: string): string {
    // Remove all non-digit characters except the leading +
    const cleanNumber = phoneNumber.replace(/[^\d+]/g, '');
    
    // Remove the + sign if present
    const finalNumber = cleanNumber.replace(/^\+/, '');
    
    return `https://wa.me/${finalNumber}`;
}